<template>
  <v-container fluid fill-height>
    <v-layout row>
      <v-flex xs12 sm4 offset-sm4>
        <v-card class="pfCard">
          <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
          <v-card-text>
            <v-container>
              <h3>Sign In</h3>
              <form @submit.prevent="onSignin">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      label="Mail"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      type="password"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <div class="text-xs-center">
                    <v-btn color="primary" type="submit" :disabled="loading">
                      Sign in
                    </v-btn>
                    <br><br>
                      <p><router-link to="/signup">Click here to register</router-link></p>
                      <p><router-link to="/password">Forgot Password</router-link></p>
                    </div>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import shared from '../../mixins/shared'

  export default {
    mixin: [shared],
    data () {
      return {
        email: '',
        password: '',
        loading: false
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      }
    },
    methods: {
      onSignin () {
        this.loading = true
        this.$fb.auth().signInWithEmailAndPassword(this.email, this.password).then(user => {
          this.$db.collection('userMeta').doc(user.uid).get().then((doc) => {
            // let doc = res.docs[0]
            this.loading = false
            if (doc.data().approved) {
              let newUser = {
                'id': user.uid,
                'firstName': doc.data().firstName,
                'lastName': doc.data().lastName,
                'email': doc.data().email,
                'telephone': doc.data().telephone,
                'role': doc.data().role,
                'address1': doc.data().address1,
                'address2': doc.data().address2,
                'town': doc.data().town,
                'county': doc.data().county,
                'postcode': doc.data().postcode
              }
              this.$store.dispatch('signUserIn', newUser)
              console.log(this.currentUser())
              this.$router.push('/issue-type')
            } else {
              this.addNotification({text: 'You are not an approved user', color: 'error'})
            }
          }).catch(error => {
            this.loading = false
            this.addNotification({text: 'Error logging in, contact support', color: 'error'})
            console.log(error)
          })
        }).catch(error => {
          this.loading = false
          this.addNotification({text: 'Username or pasword incorrect', color: 'error'})
          console.log(error)
        })
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      }
    },
    created () {
      this.$fb.auth().onAuthStateChanged((user) => {
        if (user) {
          this.$db.collection('userMeta').doc(user.uid).get().then((doc) => {
            this.loading = false
            if (doc.data().approved) {
              let newUser = {
                'id': user.uid,
                'firstName': doc.data().firstName,
                'lastName': doc.data().lastName,
                'email': doc.data().email,
                'telephone': doc.data().telephone,
                'role': doc.data().role,
                'address1': doc.data().address1,
                'address2': doc.data().address2,
                'town': doc.data().town,
                'county': doc.data().county,
                'postcode': doc.data().postcode
              }
              this.$store.dispatch('signUserIn', newUser)
              this.$router.push('/issue-type')
            }
          })
        }
      })
    }
  }
</script>
<style>
@media only screen and (max-width : 800px) {
  .pfCard.v-card {
    background-color: transparent;
    padding:  0;
    box-shadow: none
  }
  .pfCard .v-card__text {
    padding:  0;
  }
}
.logo {
  height: 45px;
  width: auto;
  margin: 0 auto;
}
.logo-span {
  text-align:  center;
  margin:  0 auto;
  display: inline-flex;
  -webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
-webkit-box-pack: center;
-ms-flex-pack: center;
justify-content: center;
position: relative;
text-align: center;
vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// Signin.vue?7a616b12